<template>
  <div id="calculadora">
    <v-app>
      <v-dialog v-model="dialogProposal">

        <v-content>
          <v-container grid-list-xl>
            <v-stepper v-model="step" alt-labels class="elevation-0 grey lighten-5">
              <v-stepper-header class="elevation-0">
                <v-stepper-step :complete="step > 1" step="1">Cadastro do cliente</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">Informações de Consumo</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3">Informações comerciais</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 4" step="4">Informações da revenda</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :key="1" :step="1">
                  <v-form ref="formClient" style="padding: 0px 24px;">
                    <ProjectClient />
                  </v-form>
                  <div class="actions">
                    <v-btn class="back-button" @click="$emit('close')">
                      FECHAR
                    </v-btn>

                    <v-btn color="#0083CA" class="white--text" @click="stepConsumption()">
                      PRÓXIMO
                    </v-btn>
                  </div>
                </v-stepper-content>

                <v-stepper-content :key="2" :step="2">
                  <v-form ref="formConsumption" style="padding: 0px 24px;">
                    <ProjectEnergyCost type="create" />
                  </v-form>

                  <div class="actions">
                    <v-btn class="back-button" @click="$emit('close')">
                      FECHAR
                    </v-btn>
                    <div>
                      <v-btn outline color="#021746" @click="previousStep()" class="back-button">
                        VOLTAR
                      </v-btn>
                      <v-btn color="#0083CA" class="white--text" @click="stepCommercial()">
                        PRÓXIMO
                      </v-btn>
                    </div>
                  </div>
                </v-stepper-content>

                <v-stepper-content :key="3" :step="3">
                  <v-layout row wrap align-center class="my-3">
                    <v-flex xs12 sm8 offset-sm2>
                      <v-card flat class="elevation-0 grey lighten-5">
                        <v-form ref="formCommercial">
                          <v-layout wrap>
                            <v-flex d-flex xs12 sm6>
                              <ProjectInstallation />
                            </v-flex>
                            <v-flex d-flex xs12 sm6>
                              <ProjectCommercialValue />
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <div class="actions">
                    <v-btn class="back-button" @click="$emit('close')">
                      FECHAR
                    </v-btn>
                    <div>
                      <v-btn outline color="#021746" @click="previousStep()" class="back-button">
                        VOLTAR
                      </v-btn>
                      <v-btn color="#0083CA" class="white--text" @click="stepContractRetail()">
                        PRÓXIMO
                      </v-btn>
                    </div>
                  </div>

                </v-stepper-content>
                <v-stepper-content :key="4" :step="4">
                  <v-form ref="formContractRetail" style="padding: 0px 24px;">
                    <ProjectContractRetail />
                  </v-form>

                  <div class="actions">
                    <v-btn class="back-button" @click="$emit('close')">
                      FECHAR
                    </v-btn>
                    <div>
                      <v-btn outline color="#021746" @click="previousStep()" class="back-button">
                        VOLTAR
                      </v-btn>
                      <v-btn color="#0083CA" class="white--text" @click="stepResume()">
                        CONCLUIR
                      </v-btn>
                    </div>
                  </div>

                  <v-layout align-center justify-center>
                    <v-dialog v-model="dialog" persistent max-width="500px">
                      <v-card>
                        <template v-if="saving">
                          <v-card-title>
                            <v-flex xs12>
                              <h3 class="primary-color text-center">
                                Salvando proposta
                              </h3>
                            </v-flex>
                          </v-card-title>
                          <v-card-text class="text-center">
                            <Loader></Loader>
                          </v-card-text>
                        </template>
                        <template v-if="!saving">
                          <v-card-title>
                            <v-flex xs12>
                              <h3 class="primary-color text-center">
                                Proposta <b>{{ this.projeto.id }}</b> salva com sucesso
                              </h3>
                            </v-flex>
                          </v-card-title>
                          <v-card-text>
                            <v-flex class="text-center" xs12>
                              <v-btn color="#0083CA" class="white--text" text
                                @click="createPDF">DOWNLOAD</v-btn>

                              <v-btn color="#021746" class="white--text" text @click="dialog = false;">EDITAR</v-btn>
                            </v-flex>
                            <br />
                            <v-divider class="grey lighten-2"></v-divider>
                            <v-layout wrap>
                              <v-flex d-flex class="text-center" xs12 sm6>
                                <v-btn outline color="#021746" @click="listarProjetos()">Ver Propostas</v-btn>
                              </v-flex>
                              <v-flex d-flex class="text-center" xs12 sm6>
                                <v-btn outline color="#021746" @click="close">Sair</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </template>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-content>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import ProjectClient from '../../solar-calculator/ProjectClient'
import ProjectInstallation from '../../solar-calculator/ProjectInstallation.vue'
import ProjectCommercialValue from '../../solar-calculator/ProjectCommercialValue.vue'
import ProjectEnergyCost from '../../solar-calculator/ProjectEnergyCost.vue'
import ProjectContractRetail from '../../solar-calculator/ProjectContractRetail.vue'
import Loader from '../Loader.vue'

import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import Vue from "vue";

export default {
  name: "Project",
  props: {
    dialogProposal: { type: Boolean, default: false },
    product: { type: Object, default: null },
    transportadora: { type: Object, default: null },
  },
  components: {
    ProjectClient,
    ProjectInstallation,
    ProjectCommercialValue,
    ProjectEnergyCost,
    ProjectContractRetail,
    Loader
  },
  mounted() {
    this.selectProduct({ id: this.product.Codigo.split("-")[0] })
    this.selectTransportadora(this.transportadora)
  },
  computed: {
    ...mapGetters(["projeto", "selectedProduct"]),
    step: {
      get() {
        return this.$store.getters.step;
      },
      set(value) {
        this.$store.commit("setStep", value);
      },
    },
  },
  data() {
    return {
      dialog: false,
      saving: false,
      print: false,
      formContatoValid: false,
    };
  },
  methods: {
    ...mapActions(["setStep", "nextStep", "previousStep", "updateProject", "resetState", "selectProduct", "calculateProject", "loadContatoRevenda", "getValoresParcelamentoSolAgora", "getValoresParcelamentoCartao", "selectTransportadora"]),

    listarProjetos() {
      this.resetState()
      this.$router.push(`${Vue.prototype.$rotaCalculadora}`)
    },

    stepConsumption() {
      if (this.$refs.formClient.validate()) {
        this.setStep(2);
      }
    },

    stepCommercial() {
      if (this.$refs.formConsumption.validate()) {
        this.calculateProject()
      }
    },

    stepContractRetail() {
      if (this.$refs.formCommercial.validate()) {
        this.setStep(4);
      }
    },

    async stepResume() {
      if (this.$refs.formContractRetail.validate()) {
        try {
          this.saving = true
          this.dialog = true
          await this.$store.dispatch("getValoresParcelamentoSolAgora", {
            cnpj: this.projeto.contatoRevenda.cnpj,
            valor: parseFloat(this.projeto.valorEUP.replace("R$", "").replace('.', '').replace(',', '.')),
            cpfCliente: this.projeto.cliente.documento,
            valorConta: this.projeto.contas
              .map(x => parseFloat(x.valor.replace("R$", "").replace('.', '').replace(',', '.')))
              .reduce((acc, valor) => acc + valor, 0)
          });
          await this.$store.dispatch("getValoresParcelamentoCartao",
            {
              codigoProduto: this.projeto.produto,
              valor: parseFloat(this.projeto.valorEUP.replace("R$ ", "").replace(".", "").replace(",", "."))
            });
          await this.saveProject()
        }
        finally {
          this.saving = false
        }
      }
    },

    async saveProject() {
      if (this.projeto.id) {
        await axios.post(`${this.$apiUrl}/Projeto.svc/projeto/${this.projeto.id}/editar`, this.projeto, { withCredentials: true })
          .then(response => {
            this.projeto.criadoEm = response.data.DataProjeto;
            this.projeto.validade = response.data.DataValidade;
          }).catch(error => {
            console.log(error)
          })
      } else {
        await axios
          .post(`${this.$apiUrl}/Projeto.svc/projeto`, this.projeto, {
            withCredentials: true,
          })
          .then((response) => {
            this.projeto.id = response.data.Id;
            this.projeto.codigo = response.data.Id;
            this.projeto.criadoEm = response.data.DataProjeto;
            this.projeto.validade = response.data.DataValidade;
          })
          .catch(() => {
            console.log(error)
          });
      }
      await this.$store.dispatch("getValoresParcelamentoCartao",
        {
          codigoProduto: this.projeto.produto,
          valor: parseFloat(this.projeto.valorEUP.replace("R$ ", "").replace(".", "").replace(",", "."))
        });
    },

    close() {
      this.dialog = false;
      this.$emit('close');
      this.resetState()
    },
    createPDF() {
      window.open("/calculadora-solar-projetos/gerar-proposta?proj=" + this.projeto.id, "")
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  padding: 0px 24px !important;
}

div#calculadora .v-stepper__content {
  padding: 0 !important;
}
</style>
